import { render, staticRenderFns } from "./SlidingBayLockDamage.vue?vue&type=template&id=4076d044&scoped=true"
import script from "./SlidingBayLockDamage.vue?vue&type=script&lang=ts"
export * from "./SlidingBayLockDamage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4076d044",
  null
  
)

export default component.exports